// extracted by mini-css-extract-plugin
export default {"menuBarRoot":"w9Ql5Lv9","hasActionBars":"bzL4RO_Y","menuGridRoot":"I4dk2Pa8"};